var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-form", {
    attrs: {
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "中文"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3
    },
    model: {
      value: _vm.form.zh,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "zh", $$v);
      },
      expression: "form.zh"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "英文"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3
    },
    model: {
      value: _vm.form.en,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "en", $$v);
      },
      expression: "form.en"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "繁体"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3
    },
    model: {
      value: _vm.form.tw,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tw", $$v);
      },
      expression: "form.tw"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("提交")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };